(function (app) {

    app.directive("uiSrefModalClick",
        [
            "figUiSrefModalService", function (figUiSrefModalService) {
                return {
                    link: function (scope, element) {
                        element.bind("click",
                            function ($event) {
                                figUiSrefModalService.$event = $event;
                            });
                    }
                };
            }
        ]);

})(window.app); //jshint ignore:line